export default __webpack_public_path__ + "static/media/TREATMENT_TYPE.b4c30ba6.png";